module.exports = __webpack_public_path__ + "img/22_77.bd3fe410.png";